import { useEffect } from "@remi/next-ui";
import { NextEvent } from "@remi/types/posthog";

import { useAnalytics } from "~/hooks/useAnalytics";

export function useCapturePwaInstall() {
  const { capturePosthogEvent } = useAnalytics();

  useEffect(() => {
    const captureInstall = () => capturePosthogEvent(NextEvent.PwaInstalled);
    window.addEventListener("appinstalled", captureInstall);
    return () => window.removeEventListener("appinstalled", captureInstall);
  }, [capturePosthogEvent]);
}
